import { BrowserRouter } from 'react-router-dom'
import { LanguageProvider } from 'i18n'
import Routes from './routes/index'

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </LanguageProvider>
  )
}
